import React from 'react';
import {
    Box,
    Container,
    Stack,
    SimpleGrid,
    Text,
    Link as ChakraLink,
    Icon,
    Image,
    VStack,
    Divider,
    Flex,
    useColorModeValue,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FaDiscord, FaReddit, FaYoutube, FaTelegram, FaFacebook } from 'react-icons/fa';
import { SiX } from 'react-icons/si';

const ListHeader = ({ children }) => {
    return (
        <Text fontWeight={'500'} fontSize={'lg'} mb={2} color="white">
            {children}
        </Text>
    );
};

const SocialButton = ({ icon, label, href }) => {
    return (
        <ChakraLink
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            transition="all 0.3s ease"
            _hover={{
                color: '#00E676',
                transform: 'translateY(-2px)',
            }}
            mr={4}
        >
            <Icon as={icon} boxSize="20px" aria-label={label} />
        </ChakraLink>
    );
};

const Footer = () => {
    return (
        <Box
            as="footer"
            bg="transparent"
            color="white"
            pb={16}
            position="relative"
            bottom={0}
            width="100%"
            bg="rgba(13, 16, 25, 0.95)"
            backdropFilter="blur(10px)"
            borderTop="1px solid"
            borderColor="whiteAlpha.200"
            color="whiteAlpha.700"
        >
            <Container as={Stack} maxW={'7xl'} py={10}>
                <SimpleGrid
                    templateColumns={{ sm: '1fr 1fr', md: '2fr 1fr 1fr 1fr' }}
                    spacing={8}
                >
                    <Stack spacing={6}>
                        <Box>
                            <Link to="/">
                                <Flex align="center" mb={2}>
                                    <Image
                                        src="/images/palm-heist-logo.png"
                                        alt="PALMHEIST Logo"
                                        boxSize="48px"
                                        objectFit="contain"
                                        mr={3}
                                    />
                                    <Text
                                        fontSize="xl"
                                        fontWeight="bold"
                                        color="white"
                                        bgGradient="linear(to-r, #00E676, #00B894)"
                                        bgClip="text"
                                    >
                                        PALMHEIST
                                    </Text>
                                </Flex>
                            </Link>
                            <Text fontSize={'sm'} mt={2}>
                                PalmHeist is revolutionizing the DeFi landscape with innovative tokenomics
                                and a commitment to community-driven growth. Join us in shaping the future
                                of decentralized finance.
                            </Text>
                        </Box>
                        <Box>
                            <ListHeader>Follow Us</ListHeader>
                            <Stack direction={'row'} spacing={0}>
                                <SocialButton icon={SiX} label="Twitter" href="https://x.com/palmheist" />
                                <SocialButton icon={FaDiscord} label="Discord" href="https://discord.gg/naUwcHsS" />
                                <SocialButton icon={FaReddit} label="Reddit" href="https://reddit.com/r/palmheist" />
                                <SocialButton icon={FaYoutube} label="YouTube" href="https://youtube.com/@palmheist" />
                                <SocialButton icon={FaTelegram} label="Telegram" href="https://t.me/palmheist" />
                                <SocialButton icon={FaFacebook} label="Facebook" href="https://facebook.com/palmheist" />
                            </Stack>
                        </Box>
                    </Stack>
                    <Stack align={'flex-start'}>
                        <ListHeader>Quick Links</ListHeader>
                        <Link to="/#tokenomics">
                            <Text _hover={{ color: '#00E676' }}>Tokenomics</Text>
                        </Link>
                        <Link to="/#roadmap">
                            <Text _hover={{ color: '#00E676' }}>Roadmap</Text>
                        </Link>
                        <Link to="/#whitepaper">
                            <Text _hover={{ color: '#00E676' }}>Whitepaper</Text>
                        </Link>
                        <Link to="/#faq">
                            <Text _hover={{ color: '#00E676' }}>FAQ</Text>
                        </Link>
                    </Stack>
                    <Stack align={'flex-start'}>
                        <ListHeader>Resources</ListHeader>
                        <Link to="/policy">
                            <Text _hover={{ color: '#00E676' }}>Privacy Policy</Text>
                        </Link>
                        <ChakraLink href="https://docs.palmheist.io" target="_blank" _hover={{ color: '#00E676' }}>
                            Documentation
                        </ChakraLink>
                        <ChakraLink href="https://github.com/palmheist" target="_blank" _hover={{ color: '#00E676' }}>
                            GitHub
                        </ChakraLink>
                        <ChakraLink href="mailto:contact@palmheist.io" _hover={{ color: '#00E676' }}>
                            Contact Us
                        </ChakraLink>
                    </Stack>
                    <Stack align={'flex-start'}>
                        <ListHeader>Legal</ListHeader>
                        <Link to="/terms">
                            <Text _hover={{ color: '#00E676' }}>Terms of Service</Text>
                        </Link>
                        <Link to="/privacy">
                            <Text _hover={{ color: '#00E676' }}>Privacy Policy</Text>
                        </Link>
                        <Link to="/disclaimer">
                            <Text _hover={{ color: '#00E676' }}>Disclaimer</Text>
                        </Link>
                        <Link to="/cookies">
                            <Text _hover={{ color: '#00E676' }}>Cookie Policy</Text>
                        </Link>
                    </Stack>
                </SimpleGrid>
            </Container>
            
            <Box
                borderTopWidth={1}
                borderStyle={'solid'}
                borderColor="whiteAlpha.200"
            >
                <Container
                    as={Stack}
                    maxW={'7xl'}
                    py={4}
                    direction={{ base: 'column', md: 'row' }}
                    spacing={4}
                    justify={{ base: 'center', md: 'space-between' }}
                    align={{ base: 'center', md: 'center' }}
                >
                    <Text> 2024 PalmHeist. All rights reserved.</Text>
                    <Text fontSize="sm">
                        Built with by the PalmHeist Team
                    </Text>
                </Container>
            </Box>
        </Box>
    );
};

export default Footer;
